import { Department } from "src/models/department";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DepartmentEntityModel = createEntityModel<Department>();
